"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VRCConfigSettingToggleMuteT = exports.VRCConfigSettingToggleMute = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class VRCConfigSettingToggleMute {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsVRCConfigSettingToggleMute(bb, obj) {
        return (obj || new VRCConfigSettingToggleMute()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsVRCConfigSettingToggleMute(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new VRCConfigSettingToggleMute()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    key(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startVRCConfigSettingToggleMute(builder) {
        builder.startObject(1);
    }
    static addKey(builder, keyOffset) {
        builder.addFieldOffset(0, keyOffset, 0);
    }
    static endVRCConfigSettingToggleMute(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createVRCConfigSettingToggleMute(builder, keyOffset) {
        VRCConfigSettingToggleMute.startVRCConfigSettingToggleMute(builder);
        VRCConfigSettingToggleMute.addKey(builder, keyOffset);
        return VRCConfigSettingToggleMute.endVRCConfigSettingToggleMute(builder);
    }
    unpack() {
        return new VRCConfigSettingToggleMuteT(this.key());
    }
    unpackTo(_o) {
        _o.key = this.key();
    }
}
exports.VRCConfigSettingToggleMute = VRCConfigSettingToggleMute;
class VRCConfigSettingToggleMuteT {
    constructor(key = null) {
        this.key = key;
    }
    pack(builder) {
        const key = (this.key !== null ? builder.createString(this.key) : 0);
        return VRCConfigSettingToggleMute.createVRCConfigSettingToggleMute(builder, key);
    }
}
exports.VRCConfigSettingToggleMuteT = VRCConfigSettingToggleMuteT;
